export default __webpack_public_path__ + "static/media/pin-icon.cfe5eeec.svg";